import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { IModule } from 'redux-state/layout/types.js';
import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { HighSeasListItem } from './high-seas-list-item.js';

export const HighSeasLink = ({ label, locationKey }: { label: string; locationKey: string }) => {
  const isLarge = useContext(ColumnLayoutContext) !== '1-column';
  if (isLarge) {
    return <HighSeasLinkLarge label={label} locationKey={locationKey} />;
  }
  return <HighSeasLinkSmall label={label} locationKey={locationKey} />;
};

const HighSeasLinkLarge = ({ label, locationKey }: { label: string; locationKey: string }) => {
  const [, setSearchParams] = useSearchParams();
  return (
    <HighSeasListItem
      label={label}
      onClick={() => {
        setSearchParams({ location: locationKey });
      }}
      location={{
        type: MarkerTypeGeneral.HighSeas,
        key: locationKey,
      }}
    />
  );
};
const HighSeasLinkSmall = ({ label, locationKey }: { label: string; locationKey: string }) => {
  const navigate = useNavigate();

  return (
    <HighSeasListItem
      label={label}
      onClick={() => navigate(`#${locationKey}`)}
      location={{
        type: MarkerTypeGeneral.HighSeas,
        key: locationKey,
      }}
    />
  );
};

export const HighSeasList = ({ isDrawer, modulePath, config }: IModule) => {
  return (
    <Tile dataModule="high-seas-list" config={config}>
      <div className="Tile-body">
        <TileBodyHeaderV2 isDrawer={isDrawer} modulePath={modulePath} config={config} />

        <ul className="LocationList u-mT-xs">
          <HighSeasLink label="Subtropic" locationKey="subtropic" />
          <HighSeasLink label="Pacific" locationKey="pacific" />
          <HighSeasLink label="Forties" locationKey="forties" />
          <HighSeasLink label="Southern" locationKey="southern" />
        </ul>
      </div>
    </Tile>
  );
};
